// One serialized SDK channel; revocation invalidates all pending events.
export function createNativeTransport(plugin) {
  let queue=Promise.resolve(), epoch=0, active=false, warned=false;
  const enqueue=work=>{queue=queue.then(work).catch(()=>{active=false;if(!warned){warned=true;console.warn('[analytics] native tracker unavailable');}});return queue;};
  const consent=(type,status)=>plugin.setConsent({type,status});
  return {
    start() {
      const current=++epoch;active=true;
      enqueue(async()=>{
        if(current!==epoch)return;
        await consent('AD_STORAGE','DENIED');await consent('AD_USER_DATA','DENIED');await consent('AD_PERSONALIZATION','DENIED');
        if(current!==epoch)return;
        await consent('ANALYTICS_STORAGE','GRANTED');
        if(current===epoch)await plugin.setEnabled({enabled:true});
      });
    },
    event(name,params) {
      const current=epoch;
      enqueue(async()=>{
        if(!active||current!==epoch)return;
        if(name==='page_view')await plugin.logEvent({name:'screen_view',params:{screen_name:params.screen,screen_class:params.screen,platform:params.platform,environment:params.environment}});
        else await plugin.logEvent({name,params});
      });
    },
    stop() {
      active=false;++epoch;
      enqueue(async()=>{
        await plugin.setEnabled({enabled:false});
        await consent('ANALYTICS_STORAGE','DENIED');await consent('AD_STORAGE','DENIED');
        await consent('AD_USER_DATA','DENIED');await consent('AD_PERSONALIZATION','DENIED');
        await plugin.resetAnalyticsData();
      });
    },
    settled:()=>queue,
  };
}
